var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reauthorizeTiktok)?_c('banner',{attrs:{"color-scheme":"alert","banner-message":_vm.$t('INBOX_MGMT.TIKTOK_REAUTHORIZE.BANNER.TEXT'),"has-action-button":"","actionButtonLabel":_vm.reauthorizeTiktok.name},on:{"click":_vm.onUpdateInbox}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }